import React, { useEffect, useRef, useState } from "react";
import { AppBar, Grid, Toolbar, useTheme } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  DESIGN_UNIT_LIST_RESET,
  SELECTED_PROJECT,
  SELECTED_UNIT_ID,
  GET_BACK_FROM_DESIGN,
  SHOW_PROJECTS,
  SET_MENU_DRAWER,
} from "Stores/actionTypes";
import { read, store } from "Helpers/LocalStorage";
import { getNotificationCount, getUserData } from "Stores/actions";
import { push } from "Helpers/History";
import Logo from "../../../../Assets/svg/logo/logo.svg";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import SelectedProjectComponent from "./SelectedProjectComponent";
import DesignToolbarMenu from "./DesignToolbarMenu";
import DashboardToolbarMenu from "./DashboardToolbarMenu";
import { isSuperAdmin } from "Helpers/analyzeToken";

function Header({ rtlLayout, isDesign }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const [needReload, setNeedReload] = useState(false);
  const [inDesignPage, setInDesignPage] = useState(false);
  const { selectedProject, isLoggedIn, getBack, menuStatus } = useSelector(
    (state) => ({
      selectedProject: state.project.selectedProject,
      isLoggedIn: state.auth.isLoggedIn,
      getBack: state.design.getBack,
      menuStatus: state.auth.menuStatus,
    })
  );
  const dispatch = useDispatch();
  const anchorRef = useRef(null);

  useEffect(() => {
    if (window.location.pathname.includes("/design/unit")) {
      setInDesignPage(true);
    } else {
      dispatch({ type: DESIGN_UNIT_LIST_RESET });
      store("unitId", undefined);
      setInDesignPage(false);
    }
  }, [window.location.pathname]);

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
  };

  const gotoProject = (URL, reload = true) => {
    if (!reload) {
      dispatch({
        type: SHOW_PROJECTS,
        value: false,
      });
    }
    dispatch({
      type: GET_BACK_FROM_DESIGN,
      mode: reload ? 1 : 3,
      address: URL,
    });
    handleClose();
  };

  useEffect(() => {
    if (getBack.mode === 2) {
      store("forceReload", true);
      store("unitId", null);
      push(getBack.URL);
      store("forceReload", false);
      setNeedReload(false);
      dispatch({ type: GET_BACK_FROM_DESIGN, mode: 0, address: null });
    } else if (getBack.mode === 3) {
      setNeedReload(false);
      dispatch({ type: GET_BACK_FROM_DESIGN, mode: 0, address: null });
      push(getBack.URL);
    }
  }, [getBack]);

  const setMenuDrawer = () => {
    dispatch({ type: SET_MENU_DRAWER, status: !menuStatus });
  };

  useEffect(() => {
    (async () => {
      if (isLoggedIn && !isSuperAdmin()) {
        dispatch({ type: SELECTED_PROJECT, selectedProject: read("project") });
        dispatch({ type: SELECTED_UNIT_ID, selectedUnitId: read("unitId") });
        try {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
          };
          await dispatch(getUserData(params));
          await dispatch(getNotificationCount());
        } catch (err) {
          console.error("[catch error]", err);
        }
      }
    })();
  }, [isLoggedIn]);

  return (
    <AppBar
      className={`appBar ${read('language_direction') === "rtl" ? "text-right" : "text-left"}`}
    >
      <Toolbar className={`rtl-${rtlLayout}`}>
        <Grid container className="px-2">
          <Grid
            item
            xs={6}
            className="d-flex flex-row align-items-center justify-content-start g-2"
          >
            {isDesign ? (
              <div>
                <img src={Logo} className="design-page-logo" alt="" />
              </div>
            ) : (
              <div className="menu-icon" onClick={setMenuDrawer}>
                <Icons.List />
              </div>
            )}
            <SelectedProjectComponent
              selectedProject={selectedProject}
              gotoProject={gotoProject}
              inDesignPage={inDesignPage}
            />
          </Grid>

          <Grid
            item
            xs={6}
            className="d-flex flex-row align-items-center justify-content-end"
          >
            {selectedProject && inDesignPage ? (
              <DesignToolbarMenu
                rtlLayout={rtlLayout}
                setReload={(value) => setNeedReload(value)}
              />
            ) : (
              <DashboardToolbarMenu
                rtlLayout={rtlLayout}
                setReload={(value) => setNeedReload(value)}
              />
            )}
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
